import type { SectionContent, WritingVersion } from '@/types'
import { v4 as uuidv4 } from 'uuid'

function toTime(value: Date | string | undefined): number {
  if (!value) return 0
  if (value instanceof Date) return value.getTime()
  return new Date(value).getTime()
}

export function sortWritingVersions(versions: WritingVersion[]): WritingVersion[] {
  return [...versions].sort((a, b) => toTime(a.createdAt) - toTime(b.createdAt))
}

export function resolveNextActiveVersionId(
  versions: WritingVersion[],
  currentActiveVersionId?: string,
): string | undefined {
  if (versions.length === 0) return undefined
  if (currentActiveVersionId && versions.some((version) => version.id === currentActiveVersionId)) {
    return currentActiveVersionId
  }
  const sorted = sortWritingVersions(versions)
  return sorted[sorted.length - 1]?.id
}

export function applyExclusiveFinalVersion(
  versions: WritingVersion[],
  targetVersionId: string,
): WritingVersion[] {
  return versions.map((version) => ({
    ...version,
    isFinal: version.id === targetVersionId,
  }))
}

export function buildDuplicatedSectionContent(
  source: SectionContent,
  sectionId: string,
  versionId: string,
): SectionContent {
  const createdAt = new Date()
  return {
    id: uuidv4(),
    sectionId,
    versionId,
    content: source.content ?? '',
    createdAt,
    updatedAt: createdAt.toISOString(),
    contentHash: undefined,
    dirty: true,
    baseRemoteHash: undefined,
    baseRemoteUpdatedAt: undefined,
    deletedAt: undefined,
    kid: undefined,
  }
}
